































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import RangeSlider from "@/components/VRangeSliderStyling.vue";
import ColorPicker from '@/commonComponents/colorPicker/colorPicker.vue';

import * as def from '@/definitions'

import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { ColorConstruct } from '@/utilityModels/colorConstruct';
import { NumberLayer } from '@/model/document2/page/surface/design/layer/numberLayer';
import { MathHelper } from '@/helper/mathHelper';

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";
import AdjustedBalloon from '@/commonComponents/adjustedBalloon/adjustedBalloon.vue';

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
      RangeSlider,
      ColorPicker,
      ColorSelector,
      AdjustedBalloon,
      ArrowDown,
      ArrowRight,
      CheckBoxOn
  },
})

export default class NumberTextShadow extends Vue
{
    @Prop() private layer! : NumberLayer;

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //こいつはpropsでもらいたい
    openStatus = {
        opend : true
    };

    textShadowContentsOpenAnimate = false;
    textShadowContentsCloseAnimate = false;

    open(){
        if(this.openStatus.opend){
            this.textShadowContentsCloseAnimate = true;
            setTimeout(()=>{this.textShadowContentsCloseAnimate = false; this.textShadowContentsOpenAnimate = false; this.openStatus.opend = false;}, 200);
        }else{
            this.openStatus.opend = true;
            this.textShadowContentsOpenAnimate = true;
            setTimeout(()=>{this.textShadowContentsOpenAnimate = false;}, 250);
        }
    };
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    // 影
    private get isShadow()
    {
        return this.layer.textInfo.isShadow;
    }

    private isShadowChange()
    {
        this.changeTextInfo(!this.isShadow, "isShadow", true, true);
    }

    // 縁取り
    private get isOutline()
    {
        return this.layer.textInfo.isOutline;
    }

    private isOutlineChange()
    {
        this.changeTextInfo(!this.isOutline, "isOutline", true, true);
    }

    // 影の距離
    private get shadowDistance() { return this.layer.textInfo.shadowDistance; }
    private get shadowDistanceDisplay() { return MathHelper.roundByDigits(this.shadowDistance).toFixed(); }
    private get shadowDistanceValue() { return this.shadowDistance; }
    private set shadowDistanceValue(value)
    {
        this.changeTextInfo(value, "shadowDistance", false);
    }
    private onChangeShadowDistance(value)
    {
        this.changeTextInfo(value, "shadowDistance", true);
    }

    // 影の角度
    private get shadowRotate() { return this.layer.textInfo.shadowRotate; }
    private get shadowRotateDisplay() { return MathHelper.roundByDigits(this.shadowRotate).toFixed(); }
    private get shadowRotateValue() { return this.shadowRotate; }
    private set shadowRotateValue(value)
    {
        this.changeTextInfo(value, "shadowRotate", false);
    }
    private onChangeShadowRotate(value)
    {
        this.changeTextInfo(value, "shadowRotate", true);
    }

    // 影のぼかし
    private get shadowBlur() { return this.layer.textInfo.shadowBlur; }
    private get shadowBlurDisplay() { return MathHelper.roundByDigits(this.shadowBlur, 1).toFixed(); }
    private get shadowBlurValue() { return this.shadowBlur; }
    private set shadowBlurValue(value)
    {
        this.changeTextInfo(value, "shadowBlur", false);
    }
    private onChangeShadowBlur(value)
    {
        this.changeTextInfo(value, "shadowBlur", true);
    }

    // 影の強さ
    private get shadowIntensity() { return this.layer.textInfo.shadowIntensity; }
    private get shadowIntensityDisplay() { return MathHelper.roundByDigits(this.shadowIntensity).toFixed(); }
    private get shadowIntensityValue() { return this.shadowIntensity; }
    private set shadowIntensityValue(value)
    {
        this.changeTextInfo(value, "shadowIntensity", false);
    }
    private onChangeShadowIntensity(value)
    {
        this.changeTextInfo(value, "shadowIntensity", true);
    }

    // 縁取りの太さ
    private get outlineThickness() { return this.layer.textInfo.outlineThickness; }
    private get outlineThicknessDisplay() { return MathHelper.roundByDigits(this.outlineThickness, 1).toFixed(); }
    private get outlineThicknessValue() { return this.outlineThickness; }
    private set outlineThicknessValue(value)
    {
        this.changeTextInfo(value, "outlineThickness", false);
    }
    private onChangeOutlineThickness(value)
    {
        this.changeTextInfo(value, "outlineThickness", true);
    }

    // 縁取りの強さ
    private get outlineIntensity() {  return this.layer.textInfo.outlineIntensity; }
    private get outlineIntensityDisplay() { return MathHelper.roundByDigits(this.outlineIntensity).toFixed(); }
    private get outlineIntensityValue() { return this.outlineIntensity; }
    private set outlineIntensityValue(value)
    {
        this.changeTextInfo(value, "outlineIntensity", false);
    }
    private onChangeOutlineIntensity(value)
    {
        this.changeTextInfo(value, "outlineIntensity", true);
    }

    // 色

    // 影色
    private get shadowColor() { return this.layer.textInfo.shadowColor; }
    private get shadowColorHex()
    {
        return this.shadowColor.hex;
    }

    private isShadowColorPickerVisible = false;
    private showShadowColorPicker()
    {
        this.isShadowColorPickerVisible = true;
    }
    private closeShadowColorPicker()
    {
        this.isShadowColorPickerVisible = false;
    }

    // 縁取り色
    private get outlineColor() { return this.layer.textInfo.outlineColor; }

    private get outlineColorHex()
    {
        return this.outlineColor.hex;
    }

    private isOutlineColorPickerVisible = false;
    private showOutlineColorPicker()
    {
        this.isOutlineColorPickerVisible = true;
    }
    private closeOutlineColorPicker()
    {
        this.isOutlineColorPickerVisible = false;
    }

    // 色変更中
    private onChangingColor(color, tag)
    {
        this.changeTextInfo(color, tag, false);
    }

    // 色変更完了
    private onChangedColor(color, tag)
    {
        this.changeTextInfo(color, tag, true);
    }

    private changeTextInfo(value : any, propertyName : string, isFinish : boolean, isOnce = false)
    {
        var textInfo = this.layer.textInfo.clone();
        textInfo[propertyName] = value;
        this.changeLayerProperty("textInfo", textInfo, isFinish, isOnce);
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("doCommand", "changeLayerProperty", { layer : this.layer, propertyName : propertyName, value : value, isFinish : isFinish, isOnce : isOnce });
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}



